/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, DestroyRef, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { OTHER_COLLECTION_ID } from 'src/app/shared/services/customer-api/query-api.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-menu-bside',
  templateUrl: './menu-bside.component.html',
  styleUrls: ['./menu-bside.component.scss'],
})
export class BsideComponent {
  params: any;

  /** Hierarchy pages and the "Other" pseudo-collection have no chart view. */
  get showCharts(): boolean {
    return (
      this.params?.type !== 'hierarchy' &&
      !(this.routing.isQuery() && this.params?.id === OTHER_COLLECTION_ID)
    );
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public routing: RoutingService,
    public featureFlagsService: FeatureFlagsService,
    private destroyRef: DestroyRef,
  ) {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.params = params;
      });
  }

  iMain() {
    this.router.navigate(['./main'], {
      queryParams: Object.assign(
        {},
        this.iQparams(),
        this.params.groupId ? { id: this.params.groupId } : null,
        this.params.portfolioId
          ? { id: this.params.portfolioId, type: null, portfolioId: null }
          : null,
        {
          sort: this.routing.isQuery()
            ? 'ratio'
            : !(
                  this.featureFlagsService.scorelabSettings.defaultScore ===
                  'sentiment'
                )
              ? 'score'
              : '-senti',
        },
      ),
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }
  iScan() {
    this.router.navigate(['./scanner'], {
      queryParams: Object.assign(
        {},
        this.iQparams(),
        this.params.groupId ? { id: this.params.groupId } : null,
        this.params.portfolioId
          ? { id: this.params.portfolioId, type: null, portfolioId: null }
          : null,
        {
          sort: !(
            this.featureFlagsService.scorelabSettings.defaultScore ===
            'sentiment'
          )
            ? 'score'
            : '-senti',
        },
      ),
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }
  iChart() {
    this.router.navigate(['./chart'], {
      queryParams: Object.assign({}, this.iQparams()),
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }
  iBenchmark() {
    this.router.navigate(['./benchmark'], {
      queryParams: this.iQparams(),
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  iNewsaudit() {
    this.router.navigate(['./audit'], {
      queryParams: this.iNewsauditParams(),
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  iQparams() {
    return {
      updatePayload: null,
      news: null,
      event: null,
      newsaudit: null,
      eventid: null,
      eventype: null,
      scoreevent: null,
      tag: null,
      newstype: null,
      eventsFromScanner: null,
      reflow: Math.random(),
      queryid: null,
      newsfeedFromQuery: null,
      score: null,
      time: this.params.score ? null : this.params.time,
    };
  }
  iNewsauditParams() {
    return {
      updatePayload: null,
      news: null,
      event: null,
      newsaudit: true,
      eventid: null,
      eventype: null,
      scoreevent: null,
      tag: null,
      newstype: 'Chronological',
      eventsFromScanner: null,
      queryid: null,
      newsfeedFromQuery: null,
      score: null,
      time: this.params.score ? null : this.params.time,
    };
  }
}
